import React from "react";

const Introduction = ({ sectionData, baseUrl }) => {
  if (!sectionData) return null;

  const getFullUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${baseUrl}/public${path}`;
  };

  // Find sections by ID based on your JSON structure
  // ID 1 = Introduction Text
  // ID 2 = Functions List & Composition PDF
  const introData = sectionData.find((item) => item.id === 1);
  const functionData = sectionData.find((item) => item.id === 2);

  return (
    <>
      {/* --- Introduction Section --- */}
      {introData && (
        <section>
          <div className="container">
            <div className="sec-title text-center">
              <h2>{introData.heading}</h2>
            </div>

            <div className="row d-flex justify-content-center align-items-center">
              {/* Image */}
              <div className="col-md-4 col-12 order-1 order-md-2 mb-3 mb-md-0">
                <img
                  src={
                    introData.image
                      ? getFullUrl(introData.image)
                      : "/assets/images/apply-img.jpg"
                  }
                  alt="Introduction"
                  className="img-fluid"
                  style={{ borderRadius: "10px" }}
                />
              </div>

              {/* Text Areas */}
              <div className="col-md-8 col-12 order-2 order-md-1">
                {introData.textareas?.map((text, index) => (
                  <p key={index} style={{ textAlign: "justify" }}>
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* --- Function Section --- */}
      {functionData && (
        <section className="iaec-section">
          <div className="container">
            <div className="sec-title text-center">
              <h2>{functionData.heading}</h2>
            </div>
            <div className="row gap-5">
              <div className="col-md-7 col-12">
                {/* Intro Text for Functions */}
                {functionData.textareas?.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}

                {/* List Points */}
                <ul className="member-list">
                  {functionData.list_points?.map((point, index) => (
                    <li key={index}>
                      <i className="fa fa-dot-circle-o"></i> {point}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Document Download Section */}
              {functionData.pdf_file && (
                <div className="col-md-3 col-12">
                  <div className="doc-card">
                    {/* Simplified Card for Single PDF */}
                    <div className="doc-slide p-4 border rounded text-center bg-light">
                      <div className="doc-content">
                        <h3 className="doc-title mb-3">
                          {functionData.pdf_name || "Composition"}
                        </h3>
                        <a
                          href={getFullUrl(functionData.pdf_file)}
                          className="btn btn-primary btn-sm doc-download"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-download me-2"></i> Download PDF
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Introduction;
